<div class="options-sidenav-content" style="padding: 20px;">
    <div class="divHeaderLine">
        <h3>Process Services</h3>
    </div>
</div>
<div class="mainTemlateDiv">
    <iframe class="templateIframe" [src]="embedURL" allow="clipboard-read; clipboard-write" width='100%'></iframe>
</div>